import pinyin  from "tiny-pinyin";
export function getPinyinFirstChar(str) {
  /*
  pinyin.js
  let py =pinyin(labelValue, {
      style: pinyin.STYLE_FIRST_LETTER, // 设置拼音风格
      heteronym: false    // 是否开启多音字。
    })

 */

  let arr =pinyin.parse(str)
  let firstCharStr = arr.map(e=>e.target.charAt(0)).join("").toLowerCase();
  return firstCharStr;
}
export function getPinyin(str) {
  let strResult =pinyin.convertToPinyin(str, '', true) // wo-men-he-ta-men
  return strResult;
}
